import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo-terts.svg'
import _imports_1 from '@/assets/brasil.png'
import _imports_2 from '@/assets/estados-unidos.png'
import _imports_3 from '@/assets/info-icon.svg'


import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const { locale, t } = useI18n();

// Função para alterar o idioma
function changeLanguage(lang: string) {
  locale.value = lang;
  localStorage.setItem("selectedLanguage", lang); // Salvando o idioma no localStorage
}

// Verificar se existe um idioma salvo no localStorage e aplicá-lo
const savedLanguage = localStorage.getItem("selectedLanguage");
if (savedLanguage) {
  locale.value = savedLanguage;
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { class: "bar-nav" }, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        class: "logo-button",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$router.push('/'))
      }, [
        _createVNode(_component_v_avatar, { size: "160px" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_0,
              alt: "Logo"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('pt')))
      }, [
        _createVNode(_component_v_avatar, { size: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_1,
              alt: "Brasil"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage('en')))
      }, [
        _createVNode(_component_v_avatar, { size: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_2,
              alt: "Estados Unidos"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("button", {
        class: "about-info",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/about')))
      }, [
        _createVNode(_component_v_avatar, { size: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _imports_3,
              alt: "Logo-Sobre"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "text-right-sobre" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('aboutPage.about')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})